import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';

import { MaintenanceInterceptor } from './maintenance.interceptor';

export function provideMaintenance(): Provider[] {
    return [{ provide: HTTP_INTERCEPTORS, useClass: MaintenanceInterceptor, multi: true }];
}
